import { Option, none, isNone, some } from 'fp-ts/lib/Option';

export default interface DeleteDashboardCriteria {
    id: string;
}

class DeleteDashboardCriteriaImpl implements DeleteDashboardCriteria {
    constructor(readonly id: string) {}
}

export class DeleteDashboardCriteriaBuilder {
    private id: Option<string> = none;

    static create = (): DeleteDashboardCriteriaBuilder => new DeleteDashboardCriteriaBuilder();

    withId = (id: string): DeleteDashboardCriteriaBuilder => {
        this.id = some(id);
        return this;
    };

    build = (): DeleteDashboardCriteria => {
        if (isNone(this.id)) {
            throw new ReferenceError('Undefined id');
        }

        return new DeleteDashboardCriteriaImpl(this.id.value);
    };
}
